// Core
import { useState } from "react";
import { useTranslations } from "next-intl";

// Definitions
import { ErrorResponse, IRegisterFieldInput } from "../types";
import { register } from "@/domains/auth/actions";

export const useAuthRegister = () => {
  const [error, setError] = useState<ErrorResponse["violations"]>([]);
  const [loading, setLoading] = useState(false);

  const tValidation = useTranslations("Validation");

  const onMutateAuth = async (mutatePayload: IRegisterFieldInput) => {
    setLoading(true);
    setError([]);

    const res = await register({
      country: mutatePayload.country,
      password: mutatePayload.password,
      login: mutatePayload.login,
      type: mutatePayload.type,
      isConfirmConditions: mutatePayload.isConfirmConditions,
      profile: {
        // country: mutatePayload.country,
        country: "UA",
        currency: mutatePayload.currency,
        utmParams: mutatePayload.utmParams,
        promoId: mutatePayload.promoId ?? null,
        promoCode: mutatePayload.promoCode ?? null,
      },
    });

    if (res?.errors) {
      setError(res.errors);
    }

    setLoading(false);

    return res;
  };

  const renderErrorMessage = (
    propertyName: string,
    authError: ErrorResponse["violations"],
  ): string | null => {
    const foundError = authError?.find((_error) => _error.property === propertyName);

    if (!foundError) return null;

    const specificKey = `${foundError.property}_${foundError.error}`;
    const fallbackKey = foundError.error;

    const specific = tValidation(specificKey);
    if (specific && specific !== `Validation.${specificKey}`) {
      return specific;
    }

    const fallback = tValidation(fallbackKey);
    if (fallback && fallback !== `Validation.${fallbackKey}`) {
      return fallback;
    }

    return null;
  };

  return {
    error,
    loading,
    onMutateAuth,
    renderErrorMessage,
  };
};
